import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './shell/App';
import './shared/theme/tokens.css';

const root = document.getElementById('root');

if (root === null) {
  throw new Error('#root is missing from index.html');
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
